import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.#initTicker();
      });
    });
  }

  #initTicker() {
    const track = this.querySelector('.announcement-bar__slides');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.announcement-bar__slide'));
    if (!slides.length) return;

    // Toutes les slides visibles
    slides.forEach((slide) => {
      slide.removeAttribute('aria-hidden');
      slide.style.cssText += 'opacity:1!important;visibility:visible!important;flex-shrink:0;padding-inline:2rem;white-space:nowrap;display:flex;align-items:center;grid-area:unset;';
    });

    // Mesurer largeur réelle AVANT clonage
    track.style.cssText += 'display:flex!important;width:max-content;max-width:none;margin-inline:0;grid:none;';
    const originalWidth = track.scrollWidth;

    // Cloner pour boucle infinie
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('aria-hidden');
      clone.style.cssText += 'opacity:1!important;visibility:visible!important;flex-shrink:0;padding-inline:2rem;white-space:nowrap;display:flex;align-items:center;grid-area:unset;';
      track.appendChild(clone);
    });

    // Injecter keyframe avec largeur exacte
    const style = document.createElement('style');
    style.textContent = `@keyframes cozyom-ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-${originalWidth}px); } }`;
    document.head.appendChild(style);

    // Appliquer animation
    track.style.animation = 'cozyom-ticker 60s linear infinite';

    // Overflow hidden
    track.parentElement.style.overflow = 'hidden';
    track.parentElement.style.width = '100%';
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}


